import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalConfirmationModule} from '../../../shared/modals/modal-confirmation/modal-confirmation.module';
import {ContentsOverviewRoutingModule} from './contents-overview-routing.module';
import {ContentsOverviewComponent} from './contents-overview.component';
import {ContentsOverviewHttpRepository} from './repositories/contents-overview.repository.http';
import {ContentsOverviewService} from './services/contents-overview.service';

import {ContentsDetailsHttpRepository} from '../contents-details/repositories/contents-details.repository.http';
import {ContentsDetailsService} from '../contents-details/services/contents-details.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ContentsOverviewRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    ContentsOverviewComponent,
  ],
  providers: [
    ContentsOverviewService,
    {
      provide: 'IContentsOverviewRepository',
      useClass: ContentsOverviewHttpRepository,
    },
    ContentsDetailsService,
    {
      provide: 'IContentsDetailsRepository',
      useClass: ContentsDetailsHttpRepository,
    },
  ],
})
export class ContentsOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-overview/contents-overview.module.ts